import "./Header.css";
import { AiOutlineHome, AiOutlineProject } from "react-icons/ai";
import { useHistory } from "react-router-dom";

const Header = () => {
  const history = useHistory();
  return (
    <div className="container">
      <div className="headerContent">
        <div className="containerButtons">
          <button className="button1" onClick={() => history.push("/")}>
            Home <AiOutlineHome />{" "}
          </button>
          <button className="button2" onClick={() => history.push("/projects")}>
            Projects <AiOutlineProject />{" "}
          </button>
        </div>
        <h3>Prazer, eu sou &lt; Anthoni Felipi /&gt;</h3>
      </div>

      <h2>Front-End developer</h2>
    </div>
  );
};
export default Header;
